import * as AvatarP from '@radix-ui/react-avatar'
import { ComponentProps, FC } from 'react'
import { keyframes, styled } from '../../config'

const appear = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
})

const Root = styled(AvatarP.Root, {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  userSelect: 'none',
  background: 'transparent',
  borderRadius: '9999px',
  aspectRatio: '1'
})
const _Image = styled(AvatarP.Image, {
  borderRadius: 'inherit',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  animation: `500ms ease-out ${appear}`
})
const Fallback = styled(AvatarP.Fallback, {
  borderRadius: 'inherit',
  width: '100%',
  height: '100%',
  backgroundColor: '$blackA050',
  animation: `200ms ease-out ${appear}`
})

export const AvatarPrimitive = {
  Root: Root,
  Image: _Image,
  Fallback: Fallback
}

/**
 * Lazy Avatar.
 * Has a Fallback mechanism that renders a gray container instead of an image in case of error or loading state after 200ms.
 * You can just set width or height value. It has aspectRatio of 1.
 * Animated appear
 */
export const Avatar: FC<ComponentProps<typeof Root> & { src?: string }> = ({
  src,
  children,
  ...props
}) => (
  <Root {...props}>
    <_Image src={src} />
    <Fallback delayMs={200} />
    {children}
  </Root>
)
